import { useEffect, useState } from 'react';
import { getAppVersion } from '../api/app';

// Popup NHẮC CÀI APP — chỉ hiện khi mở FunnyTask bằng TRÌNH DUYỆT MOBILE (Android/iOS) mà CHƯA cài app
// (không phải app native Capacitor, không phải PWA đã "Thêm vào màn hình chính"). Dẫn link tải luôn:
// Android = file APK (lấy từ /api/app/version — cùng nguồn với nút Cập nhật), iOS = TestFlight.
const isAndroid = () => /Android/i.test(navigator.userAgent);
const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
const isStandalone = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
const isNative = () => !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());

const TESTFLIGHT_URL = 'https://testflight.apple.com/join/Wp2wjufX';
// Link tải APK dự phòng (khi /api/app/version lỗi): dùng link Drive trực tiếp — nguồn đang host thật.
// Bình thường sẽ lấy link mới nhất từ /api/app/version (getAppVersion) để luôn đúng bản.
const APK_FALLBACK = 'https://drive.usercontent.google.com/download?id=1StCPBKepnq7s0V7RemX-Bfo5gS13gqHJ&export=download&confirm=t';
const DISMISS_KEY = 'ft_install_prompt_at';
const COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000; // bấm "Để sau" -> im 3 ngày rồi mới nhắc lại

export default function InstallAppPrompt() {
  const [show, setShow] = useState(false);
  const [apkUrl, setApkUrl] = useState(APK_FALLBACK);
  const [ver, setVer] = useState('');
  const android = isAndroid();
  const ios = isIOS();

  useEffect(() => {
    if (isNative() || isStandalone()) return; // đã ở trong app / đã cài PWA -> không nhắc
    if (!android && !ios) return; // chỉ nhắc trên điện thoại
    const at = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (at && Date.now() - at < COOLDOWN_MS) return; // vừa tắt gần đây
    setShow(true);
    if (android) {
      // Lấy link APK + số bản mới nhất từ nguồn chuẩn (app-version.json). Lỗi thì dùng link dự phòng.
      getAppVersion()
        .then((data) => { if (data?.android?.url) setApkUrl(data.android.url); if (data?.android?.versionName) setVer(data.android.versionName); })
        .catch(() => {});
    }
  }, [android, ios]);

  if (!show) return null;
  const dismiss = () => { try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch { /* */ } setShow(false); };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 3200,
      background: 'rgba(15,20,40,.55)', backdropFilter: 'blur(2px)',
      display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
      padding: `20px 16px calc(20px + env(safe-area-inset-bottom))`,
    }}>
      <div style={{
        width: 'min(440px, 100%)', background: 'var(--panel, #fff)', borderRadius: 20,
        padding: '22px 20px', boxShadow: '0 20px 60px rgba(10,20,60,.35)', textAlign: 'center',
      }}>
        <div style={{ fontSize: 46, lineHeight: 1, marginBottom: 4 }}>📲</div>
        <h3 style={{ margin: '4px 0 4px', fontSize: 20 }}>Cài app FunnyTask</h3>
        <div className="small" style={{ color: 'var(--text2, #555)', marginBottom: 16, lineHeight: 1.5 }}>
          Cài app để nhận <b>thông báo tin nhắn</b>, <b>chấm công bằng camera</b> và dùng mượt hơn nhiều so với mở web.
        </div>

        {android && (
          <a className="btn" href={apkUrl} target="_blank" rel="noopener noreferrer"
            style={{ width: '100%', justifyContent: 'center', fontWeight: 700, padding: '12px', marginBottom: 8 }}>
            ⬇️ Tải app Android{ver ? ` (bản ${ver})` : ''}
          </a>
        )}
        {ios && (
          <a className="btn" href={TESTFLIGHT_URL} target="_blank" rel="noopener noreferrer"
            style={{ width: '100%', justifyContent: 'center', fontWeight: 700, padding: '12px', marginBottom: 8 }}>
            ⬇️ Cài app iOS (qua TestFlight)
          </a>
        )}

        {android && (
          <div className="small muted" style={{ margin: '2px 0 10px', lineHeight: 1.45 }}>
            Sau khi tải xong, mở file để cài. Lần đầu Android hỏi <b>"Cho phép cài ứng dụng"</b> → bật là xong.
          </div>
        )}

        <button className="btn ghost" onClick={dismiss}
          style={{ width: '100%', justifyContent: 'center' }}>
          Để sau
        </button>
      </div>
    </div>
  );
}
